const FilePdfIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
  >
    <g id="FilePdf" clipPath="url(#clip0_1100_59151)">
      <path
        id="Vector"
        fill="#000"
        fillOpacity="0.85"
        d="m9.387 10.254.006-.029c.117-.48.263-1.078.149-1.62-.076-.429-.392-.595-.661-.607-.317-.015-.6.166-.671.43-.133.482-.014 1.14.203 1.98-.273.651-.71 1.597-1.029 2.16-.594.307-1.392.781-1.51 1.38a.6.6 0 0 0 .07.378c.074.14.193.249.331.301.06.022.133.04.217.04.354 0 .927-.285 1.69-1.595.116-.038.237-.078.353-.118.547-.185 1.113-.378 1.626-.465.566.304 1.211.499 1.649.499.434 0 .605-.257.669-.412.113-.271.058-.613-.124-.796-.266-.26-.91-.33-1.915-.205-.494-.3-.818-.71-1.053-1.321m-2.204 3.051c-.279.406-.49.609-.604.697.134-.247.398-.508.604-.697m1.76-4.73c.105.178.09.718.01.992-.098-.4-.112-.967-.054-1.033q.023.002.044.04m-.032 2.42c.215.372.486.69.786.928-.434.098-.83.261-1.184.406l-.247.1c.267-.484.49-1.032.645-1.434m3.126 1.316c.002.004.004.01-.008.018h-.004l-.004.006c-.016.01-.18.106-.89-.173.816-.038.904.147.906.149m3.845-7.799L11.56.189A.64.64 0 0 0 11.105 0H2.57a.64.64 0 0 0-.643.643v16.714c0 .356.287.643.643.643h12.857a.64.64 0 0 0 .643-.643V4.968a.65.65 0 0 0-.189-.456m-1.294.751h-3.78v-3.78zm.037 11.29H3.374V1.447h6.067v4.34a.844.844 0 0 0 .843.843h4.34z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_1100_59151">
        <path fill="#fff" d="M0 0h18v18H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default FilePdfIcon;
